import React from "react";
import { useNavigate } from "react-router-dom";
import { Camera, Play } from "./StudentModuleIcons";

const EnrolledCourseCard = ({ course }) => {
  const navigate = useNavigate();
  const courseId = course?.course?._id;
  const enrollmentId = course?.enrollmentId;
  const isRecorded =
    (course?.enrollmentType || "").toLowerCase() === "recorded lectures";
  const sessionRoute = isRecorded ? "recorded-session" : "live-session";

  return (
    <div>
      <article className="overflow-hidden border-[0.5px] border-[#938A96] bg-white">
        <div
          className="relative h-[181px] bg-cover bg-center"
          style={{
            backgroundImage: `url(${course?.course?.courseThumbnail.secureUrl})`,
          }}
        >
          <div className="absolute left-1/2 top-1/2 flex w-fit -translate-x-1/2 -translate-y-1/2 items-center gap-2.5 bg-white/70 px-[34.5px] py-[23.5px] text-base leading-5 font-medium text-[#1D2026] backdrop-blur-sm">
            <Camera />
            <span className="flex-1 whitespace-nowrap">
              {" "}
              {(course?.enrollmentType || "").toLowerCase() === "recorded lectures"
                ? "Recorded Session"
                : "Live Session"}
            </span>
          </div>
        </div>

        <div className="pt-6 px-5">
          <h3 className="min-h-12 text-base font-medium text-[#1D2026] tracking-[-1%]">
            {course?.course?.courseTitle}
          </h3>

          <div className="mt-3">
            <div className="mb-2.5 flex items-center justify-between text-xs text-black leading-[14px]">
              <span>Progress</span>
              <span>{course?.progress?.completed}%</span>
            </div>
            <div className="h-[3px] w-full bg-[#D9D9D9]">
              <div
                className="h-full bg-[#FF6636]"
                style={{ width: `${course?.progress?.completed}%` }}
              />
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={() => {
            if (!courseId) return;
            navigate(`/student/${sessionRoute}/${courseId}`, {
              state: { enrollmentId },
            });
          }}
          className="mt-3 flex w-full items-center justify-center gap-3 bg-[#FF6636] py-[13px] text-sm font-bold text-white tracking-[-1%]"
        >
          <Play />
          Continue Learning
        </button>
      </article>
    </div>
  );
};

export default EnrolledCourseCard;
